import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionIndex from './components/SectionIndex';
import SectionComments from './components/SectionComments';
import SectionUpdates from './components/SectionUpdates';
import SectionApp from './components/SectionApp';
import SectionContact from './components/SectionContact';
import SectionFeatures from './components/SectionFeatures';
import SectionCarousel from './components/SectionCarousel';
import SectionCards from './components/SectionCards';
import SectionMedia from './components/SectionMedia';
import SectionRanking from './components/SectionRanking';
import SectionFAQ from './components/SectionFAQ';
import SectionAbout from './components/SectionAbout';
import SectionTopics from './components/SectionTopics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50">
      <Header />
      <main>
        <HeroSection />
        <SectionIndex />
        <SectionComments />
        <SectionUpdates />
        <SectionApp />
        <SectionContact />
        <SectionFeatures />
        <SectionCarousel />
        <SectionCards />
        <SectionMedia />
        <SectionRanking />
        <SectionFAQ />
        <SectionAbout />
        <SectionTopics />
      </main>
      <Footer />
    </div>
  );
}